const Colors = {
    brand: {
        primary: {
            darkest: '#008488',
            dark: '#40B7B9',
            medium: '#9FDBDC',
            light: '#F5FBFB'
        },
        secondary: {
            darkest: '#002740',
            dark: '#003A60',
            medium: '#6B809D',
            light: '#F8F9FD'
        },
    },
    neutral: {
        dark: {
            base: '#303133',
            '01': '#595A5C',
            '02': '#979899',
            '03': '#E0E0E0'
        },
        light: {
            base: '#FFFFFF',
            '01': '#FAFAFA',
            '02': '#F5F5F5',
            '03': '#EFEFEF'
        },
    },
    feedback: {
        success: {
            darkest: '#215924',
            dark: '#2E7D32',
            medium: '#97BE98',
            light: '#F5F8F5'
        },
        info: {
            darkest: '#01588C',
            dark: '#0277BD',
            medium: '#80BBDE',
            light: '#F5F8F5'
        },
        danger: {
            darkest: '#BF2B2B',
            dark: '#D32F2F',
            medium: '#E99797',
            light: '#FDF5F5'
        },
        warning: {
            darkest: '#E5A100',
            dark: '#FFB300',
            medium: '#FFD980',
            light: '#FFFBF2'
        },
        attention: {
            darkest: '#B23F00',
            dark: '#E65100',
            medium: '#F28C55',
            light: '#F2B391'
        }
    },
    support: {
        social: {
            whatsapp: '#455A64',
            facebook: '#1877F2',
        },
    },
    passemix: {
        primary: '#F6F6FC',
        white: '#FFFFFF',
        blue: '#0C395D',
        blue_primary: '#0077B3',
        blue_secondary: '#C7E1EE',
        blue_alternative: '#008488',
        grey_dark: '#303133',
        grey_light: '#575757',
        success: '#137835',
        warning: '#DE632E',
        warning_light: '#FAAD14',
        danger: '#D32F2F',
        info: '#008488'
    }
}

export default Colors
